import { userService } from "../services";
import config from "../config/config";

export const updatePassword = {
  changePassword,
  fetchForgotPassword,
  fetchOtpVeryfy,
  fetchResetPaassword,
};
async function changePassword(payload, showSnackbar) {
  console.log(payload);
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.changePassword}`;
    let response = await userService.post(apiEndpoint, payload);
    if (response && response.status == 200) {
      return response?.data;
    } else {
      // showSnackbar(response?.statusText, "error");
      return response.data;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}
async function fetchForgotPassword(payload) {
  debugger;
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.forgotPassword}?email=${payload?.email}`;
    let response = await userService.forgotePassword(apiEndpoint, payload);
    if (response && response?.status == 200) {
      return response?.data;
    } else {
      // showSnackbar(response?.statusText, "error");
      return response?.data;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function fetchOtpVeryfy(payload) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.verifyOtp}?otp=${payload?.otp}&email=${payload?.email}`;
    let response = await userService.forgotePassword(apiEndpoint, payload);
    if (response && response.status == 200) {
      return response?.data;
    } else {
      // showSnackbar(response?.statusText, "error");
      return response.data;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function fetchResetPaassword(payload) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.resetPassword}?email=${payload.email}&password=${payload.password}`;
    let response = await userService.forgotePassword(apiEndpoint, payload);
    if (response && response.status == 200) {
      return response?.data;
    } else {
      // showSnackbar(response?.statusText, "error");
      return response.data;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}
